// extracted by mini-css-extract-plugin
export default {"loadingNewValue":"LoadingDashboardValue_loadingNewValue"};